import React, { useState } from "react";
import { Table, Empty, Typography } from "antd";

const { Text } = Typography;

const PrinterStockCard = ({ printstockData }) => {
  const [loading] = useState(false);

  const columns = [
    {
      title: "Printer",
      dataIndex: "printer_name",
      key: "printer_name",
    },
    {
      title: "Offer",
      dataIndex: "offer_code",
      key: "offer_code",
    },
    {
      title: "Cost per Unit",
      dataIndex: "cost_per_unit",
      key: "cost_per_unit",
      render: (val) =>
        Number(val).toLocaleString(undefined, {
          minimumFractionDigits: 4,
          maximumFractionDigits: 4,
        }),
    },
    {
      title: "Qty Available",
      dataIndex: "quantity_available",
      key: "quantity_available",
      render: (val) => (
        <Text type={val > 0 ? "success" : "danger"}>
          {Number(val).toLocaleString()}
        </Text>
      ),
    },
    {
      title: "Date Received",
      dataIndex: "date_received",
      key: "date_received",
      render: (val) => (
        <Text>{new Date(val).toLocaleDateString()}</Text>
      ),
    },
  ];

  return (
    <div>
      {printstockData && printstockData.length > 0 ? (
        <Table
          columns={columns}
          dataSource={printstockData}
          rowKey="id"
          size="small"
          pagination={false}
          loading={loading}
          scroll={{ x: "max-content" }}
        />
      ) : (
        <Empty
          description={
            loading ? "Loading..." : "No stock information available"
          }
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      )}
    </div>
  );
};

export default PrinterStockCard;
